import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ActivityListPageRoutingModule } from './activity-list-routing.module';

import { ActivityListPage } from './activity-list.page';
import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { StylistPickerModule } from '../../components/stylist-picker/stylist-picker.module';
//import { BookingItemModule } from '../../../components/booking-item/booking-item.module';
import { SharedModule } from '../../shared.module';
import { CircleTextAvatarComponentModule } from '../../components/shared/circle-text-avatar/circle-text-avatar.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ActivityListPageRoutingModule,
    StylistPickerModule,
    SalonMonsterLoadMaskModule,
    //BookingItemModule,
    SharedModule,
    CircleTextAvatarComponentModule
  ],
  declarations: [ActivityListPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ActivityListPageModule {}
